import { render, staticRenderFns } from "./Complement.vue?vue&type=template&id=01f00c8a&"
import script from "./Complement.vue?vue&type=script&lang=js&"
export * from "./Complement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports